module.exports = __webpack_public_path__ + "media/images/sign-in-logo-f1cdf642a2e7ab83b95379659e2c2b18.png";